import { render, staticRenderFns } from "./TLocationVirtual.vue?vue&type=template&id=155d8630&"
import script from "./TLocationVirtual.vue?vue&type=script&lang=js&"
export * from "./TLocationVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports